import { getConfig } from './config';
import { AuthUser, getUserId } from '@enroller/utils';
import { browserTracingIntegration, init, replayIntegration, setUser } from '@sentry/react';

export const initSentry = () => {
  const { sentryDsn, sentryReplaySampleRate, sentryTraceSampleRate, environment, apiUrl, version } = getConfig();

  if (environment === 'local') {
    console.info(`Skipping Sentry initialisation in local environment`);
    return;
  }
  if (!sentryDsn) return;

  const sentryEnvironment: 'staging' | 'uat' | 'production' = environment === 'development' ? 'staging' : environment;

  init({
    dsn: sentryDsn,
    tracePropagationTargets: [apiUrl],
    integrations: [browserTracingIntegration(), replayIntegration({ maskAllText: false, blockAllMedia: false })],
    tracesSampleRate: sentryTraceSampleRate,
    environment: sentryEnvironment,
    release: version,
    replaysSessionSampleRate: sentryReplaySampleRate,
    replaysOnErrorSampleRate: 1.0,
  });
};

export const setSentryUser = (user: AuthUser) => {
  setUser({
    username: user.name,
    email: user.email,
    id: getUserId(user),
  });
};
